// extracted by mini-css-extract-plugin
export default {"container":"ErrorStation_container__Olu4z","details":"ErrorStation_details__QKzNu"};